import { render } from "./ConfirmClaimGenerationModal.vue?vue&type=template&id=28994632&scoped=true"
import script from "./ConfirmClaimGenerationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmClaimGenerationModal.vue?vue&type=script&lang=js"

import "./ConfirmClaimGenerationModal.vue?vue&type=style&index=0&id=28994632&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28994632"]])

export default __exports__